import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/manipulation';
import 'swiper/css/free-mode';

import Swiper from 'swiper';
import { Navigation, Manipulation, FreeMode, Autoplay } from 'swiper/modules';

import {
    sentryAPIErrorV2,
} from './module_common';

import {processImageElement} from './module_lazyload';

function defaultCarouselSetupLightLoop (containerClass, outClass, initialSlideIdx, onSlideChange) {
    const outSelector = "."+outClass;
    const containerSelector = "."+containerClass
    const swiper_cont = $(containerSelector);
    if (swiper_cont.length === 0) return

    const mobileSlides = 'auto'
    const tabletSlides = 'auto'
    const desktopSlides= 3
    const desktopBigSlides = 4

    const startAutoplayAfterMilliseconds = 10000
    const autolplayDelay = 5000

    var swiper = new Swiper(containerSelector, {
        modules: [Navigation, Manipulation, FreeMode, Autoplay],
        slidesPerView: mobileSlides,
        slidesPerGroup: 1,
        spaceBetween: 16,
        loop: true,
        initialSlide: initialSlideIdx,
        centeredSlides: true,
        autoplay: {
            delay: autolplayDelay,
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: outSelector + ' .swiper-next',
            prevEl: outSelector + ' .swiper-prev',
        },
        allowTouchMove: true,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: tabletSlides,
                allowTouchMove: true,
                spaceBetween: 16,
                slideToClickedSlide: true,
            },
            992: {
                slidesPerView: desktopSlides,
                allowTouchMove: false,
                spaceBetween: 24,
                slideToClickedSlide: true,
                centeredSlides: false,
            },
            1199: {
                slidesPerView: desktopBigSlides,
                allowTouchMove: false,
                spaceBetween: 24,
                slideToClickedSlide: true,
                centeredSlides: false,
            }
        },
        on: {
            init: function (sw) {
                swiper_cont.addClass("ready")
                sw.autoplay.stop()
                setTimeout(
                    function() {
                      sw.autoplay.start()
                    }, 
                    startAutoplayAfterMilliseconds
                );
            },
            setTranslate: function(){
                swiper_cont.addClass("mobile-ready")
            }
        }
    });

    window.skillSwiper = swiper

    swiper.on('realIndexChange', function(sw){
        const idx = sw.realIndex
        const slide = $('*[data-swiper-slide-index='+idx+']')
        const newSkillSlug = slide.data('skill-slug')
        onSlideChange(newSkillSlug)
    })
}

function booksSkillCarouselSetup (containerClass, outClass, mobileSlides, tabletSlides, desktopSlides, desktopBigSlides, searchCardsEndpoint) {
    const outSelector = "."+outClass;
    const containerSelector = "."+containerClass
    const swiper_cont = $(containerSelector);
    if (swiper_cont.length === 0) return

    var swiper = new Swiper(containerSelector, {
        modules: [Navigation, Manipulation, FreeMode],
        slidesPerView: mobileSlides,
        slidesPerGroup: 1,
        spaceBetween: 16,
        centeredSlides: true,
        freeMode: {
            enabled: true,
            sticky: true,
        },
        navigation: {
            nextEl: outSelector + ' .swiper-next',
            prevEl: outSelector + ' .swiper-prev',
        },
        allowTouchMove: true,
        watchSlidesProgress: true,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: tabletSlides,
                slidesPerGroup: 1,
                allowTouchMove: true,
                spaceBetween: 16,
                freeMode: {
                    enabled: true,
                },
            },
            992: {
                slidesPerView: desktopSlides,
                slidesPerGroup: desktopSlides,
                allowTouchMove: false,
                spaceBetween: 24,
                freeMode: {
                    enabled: false,
                },
            },
            1199: {
                allowTouchMove: false,
                slidesPerView: desktopBigSlides,
                slidesPerGroup: desktopBigSlides,
                centeredSlides: false,
                spaceBetween: 24,
                freeMode: {
                    enabled: false,
                },
            }
        },
        on: {
            init: function (sw) {
                swiper_cont.addClass("ready")
                swiper_cont.addClass("mobile-ready")
            },
        }
    });

    window.bookskillSwiper = swiper

}

let stopAutoplay = false
let pauseAutoplay = false

const lightSkillCarouselSetUp = function(){
    const out = "skill-light-out"
    const container = "skill-light-swiper-container"
    // firstSkillIdx defined in twig template
    defaultCarouselSetupLightLoop(container, out, firstSkillIdx, onSkillChange)
}

const updateSkillDataBlock = function (data){
    $('.sk-title-dyn').each(function(){
        $(this).text(data.skill_title)
    })
    $('.sk-subtitle-dyn').each(function(){
        $(this).text(data.skill_subtitle)
    })
    $('.sk-modules-dyn').each(function(){
        $(this).text(data.skill_modules)
    })
    $('.sk-books-dyn').each(function(){
        $(this).text(data.skill_total_books)
    })
}

const updateBookCarouselBlock = function(data){
    for (const book of data){
        updateBookCard("landing-book-"+book.idx, book)
    }
}

const updateBookCard = function(cardClass, data){
    const elClass = function(eClass){
        return '.'+cardClass+' .'+eClass
    }
    $(elClass('content-card-link')).each(function(){
        $(this).attr('href', data.link)
    })

    if (data.image){
        $(elClass('card-book-img')).each(function(){
            $('<div class="custom-lazy-preloader"></div>').insertAfter($(this))
            $(this).attr('src', data.image)
            $(this).removeClass("hide-cover")
            processImageElement($(this)[0])
        })
        $(elClass('alt-cover')).each(function(){
            $(this).addClass("hide-cover")
        })
    }else{
        $(elClass('card-book-img')).each(function(){
            $(this).addClass("hide-cover")
        })
        $(elClass('alt-cover')).each(function(){
            $(this).removeClass("hide-cover")
        })
        $(elClass('alt-cover-title')).each(function(){
            const colorCls = data.coverColorCls
            const altCoverClasses = `alt-cover-title ${colorCls}`
            $(this).attr('class', altCoverClasses)
        })
        $(elClass('alt-cover-title-p-ref')).each(function(){
            $(this).text(data.title)
        })
        $(elClass('alt-cover-author-p-ref')).each(function(){
            $(this).text(data.author)
        })
    }

    $(elClass('content-card-title h3')).each(function(){
        $(this).text(data.title)
    })
    $(elClass('content-card-catchline p')).each(function(){
        $(this).text(data.catchline)
    })
    $(elClass('content-card-author p')).each(function(){
        $(this).text(data.author)
    })
}

const manageBookCarouselUpdate = function(slug){
    const data = getSkillBookFromSkillBooks(slug)
    updateSkillDataBlock(data.skill)
    updateBookCarouselBlock(data.books)
}

const getSkillBookFromSkillBooks = function(slug){
    for (const skillBook of skillBooks){
        if (skillBook.skill.skill_slug == slug){
            return skillBook
        }
    }
    return null
}

const onSkillChange = function(newSlug){

    if (getSkillBookFromSkillBooks(newSlug) != null){
        manageBookCarouselUpdate(newSlug)
        return
    }
    const method = "POST"
    const postData = {
        skill: newSlug,
    }
    $.ajax({
        method: method,
        url: searchEndPoint,
        data: postData,
        dataType: 'json',
        success: function(data){
          skillBooks.push(data.skillBooks)
          manageBookCarouselUpdate(data.skillBooks.skill.skill_slug)
        },
        error: function(err){
            const contextData = {
                apicalldata: {
                    function: "onSkillChange",
                    url: searchEndPoint,
                    method: method,
                    data: JSON.stringify(postData),
                    status: err.status,
                    response: err.responseJSON,
                    readystate: err.readyState,
                    responsetype: err.responseType,
                    statustext: err.statusText,
                    responseXML: err.responseXML,
                }
            }
            if (!err.status){
                contextData.apicalldata.status = "Maybe Network error, unreachable URL, request is interrupted"
            }
            const error = new Error('onSkillChange error', {cause: err})
            error.name = 'onSkillChange fails complete error'
            sentryAPIErrorV2(error, contextData)
        }
    })
}

const bookCarouselSetUp = function(){
    const out = "book-landing-out"
    const container = "book-landing-swiper-container"
    booksSkillCarouselSetup(container, out, 'auto', 4, 4, 4)
}

const attachAutoplayInteraction = function(){
    if (typeof bookskillSwiper === 'undefined') return
    if (typeof skillSwiper === 'undefined') return
    const bookCardElements = $(".content-card-book")

    bookCardElements.hover(
        function(){
            // In
            pauseAutoplay = true
            if (skillSwiper && skillSwiper.autoplay.running) skillSwiper.autoplay.pause()
        }, 
        function(){
            // out
            pauseAutoplay = false
            if (skillSwiper && skillSwiper.autoplay.paused) skillSwiper.autoplay.resume()
        }
    )

    bookskillSwiper.on('activeIndexChange', function(){
        stopAutoplay = true
        if (skillSwiper && skillSwiper.autoplay.running) skillSwiper.autoplay.stop()
    })

    skillSwiper.on('autoplayStart', function(){
        if (stopAutoplay){
            skillSwiper.autoplay.stop()
        }
        
        if (pauseAutoplay){
            skillSwiper.autoplay.pause()
        }
    })
    
}

export const configSkillBooksCarousel = function(){
    lightSkillCarouselSetUp()
    bookCarouselSetUp()

    attachAutoplayInteraction()
}